import React from 'react';
import PropTypes from 'prop-types';
import { styled, Pagination, Tooltip, Box } from '@mui/material';

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  '& button': {
    color: theme.palette.primary.main,
    borderRadius: '100px',
    border: `1px solid ${theme.palette.primary.main}`,
    width: '48px',
    height: '48px'
  },
  '.MuiPaginationItem-previousNext': {
    color: theme.palette.primary.main,
    border: `1px solid rgba(0,0,0,0.23)`
  },
  '.Mui-selected': {
    color: theme.palette.action.default,
    background: theme.palette.primary.main
  },
  '.Mui-selected:hover': {
    background: theme.palette.primary.main
  }
}));

export const CustomPagination = ({ tooltip, disabled, ...props }) => {
  return disabled && tooltip ?
    <Tooltip title={tooltip} arrow sx={{pointerEvents: 'auto'}}>
      <Box component="span" data-testid="Wrapper">
        <StyledPagination {...props} variant="outlined" disabled={disabled} />
      </Box>
    </Tooltip> :
    <StyledPagination {...props} disabled={disabled} variant="outlined" />;
};

CustomPagination.propTypes = {
  count: PropTypes.number,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool
};

CustomPagination.defaultProps = {
  value: undefined
};
